import { render, staticRenderFns } from "./IntroductionSection.vue?vue&type=template&id=aae64ae2&scoped=true&"
import script from "./IntroductionSection.vue?vue&type=script&lang=js&"
export * from "./IntroductionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae64ae2",
  null
  
)

export default component.exports